import {useEffect, useState} from 'react';
import {isMobile as isMobileDevice} from 'react-device-detect';

/**
 * Šířka viewportu (v px), pod kterou se public Mapio přepne do mobilního zobrazení.
 * Odpovídá standardnímu "md" breakpointu UI kitu (@mc/ui-v4 / Bootstrap).
 */
export const MOBILE_BREAKPOINT = 768;

const MOBILE_MEDIA_QUERY = `(max-width: ${MOBILE_BREAKPOINT - 0.02}px)`;

const matchesMobileViewport = (): boolean =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(MOBILE_MEDIA_QUERY).matches;

/**
 * Vrací true, pokud má aplikace zobrazit mobilní rozhraní – tedy buď jde o mobilní
 * zařízení (detekce přes user-agent), nebo je viewport užší než {@link MOBILE_BREAKPOINT}.
 *
 * Díky reakci na změnu velikosti okna se mobilní vzhled aktivuje i v desktopovém
 * prohlížeči po zúžení okna (MCW-28417).
 */
export const useIsMobile = (): boolean => {
    const [isNarrowViewport, setIsNarrowViewport] = useState<boolean>(matchesMobileViewport);

    useEffect(() => {
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
            return;
        }
        const mediaQueryList = window.matchMedia(MOBILE_MEDIA_QUERY);
        const handleChange = (event: MediaQueryListEvent) => setIsNarrowViewport(event.matches);

        // Synchronizace s aktuálním stavem (okno se mohlo zmenšit před připojením listeneru).
        setIsNarrowViewport(mediaQueryList.matches);

        // addEventListener není dostupné ve starších Safari – fallback na addListener.
        if (typeof mediaQueryList.addEventListener === 'function') {
            mediaQueryList.addEventListener('change', handleChange);
            return () => mediaQueryList.removeEventListener('change', handleChange);
        }
        mediaQueryList.addListener(handleChange);
        return () => mediaQueryList.removeListener(handleChange);
    }, []);

    return isMobileDevice || isNarrowViewport;
};
